<template>
  <div class="column-edit-size">
    <el-input v-model.number="sizeLength" type="number" size="mini" data-index="sizeLength" @input="handleChange" />
    <span>*</span>
    <el-input v-model.number="sizeWidth" type="number" size="mini" data-index="sizeWidth" @input="handleChange" />
    <span>*</span>
    <el-input v-model.number="sizeHeight" type="number" size="mini" data-index="sizeHeight" @input="handleChange" />
    <span>*</span>
    <el-input v-model.number="sizeQuantity" type="number" size="mini" data-index="sizeQuantity" @input="handleChange" />
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'CargoAgGridColumnEditGroup',
  data() {
    return {
      custom: null,
      valueChanged: null,
      sizeLength: 0,
      sizeWidth: 0,
      sizeHeight: 0,
      sizeQuantity: 0
    }
  },
  created() {
    this.custom = this.params
    this.sizeLength = parseInt(this.custom.data.sizeLength)
    this.sizeWidth = parseInt(this.custom.data.sizeWidth)
    this.sizeHeight = parseInt(this.custom.data.sizeHeight)
    this.sizeQuantity = parseInt(this.custom.data.sizeQuantity)
    this.valueChanged = this.custom.valueChanged
  },
  methods: {
    handleChange() {
      this.custom.data.sizeLength = parseInt(this.sizeLength)
      this.custom.data.sizeWidth = parseInt(this.sizeWidth)
      this.custom.data.sizeHeight = parseInt(this.sizeHeight)
      this.custom.data.sizeQuantity = parseInt(this.sizeQuantity)
      this.valueChanged(this.custom)
    }
  }
})
</script>

<style lang="scss" scoped>
.column-edit-size{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 2px 10px;
  .el-input{
    height: 24px;
    line-height: 24px;
    /deep/ .el-input__inner{
      height: 24px;
      text-align: right;
    }
  }
  span{
    height: 24px;
    line-height: 30px;
    font-size: 18px;
  }
}
</style>
